import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useRouteData } from 'react-static';
// import baseLogo from '../../assets/images/home/base/logo.png';
// import comedyLogo from '../../assets/images/home/comedy/logo.png';
// import epicsLogo from '../../assets/images/home/epic/logo.png';
// import horrorLogo from '../../assets/images/home/horror/logo.png';
import arrowBtn from '../../assets/images/home/arrow.png';
import closeBtn from '../../assets/images/home/close.png';
import fbLogo from '../../assets/images/home/social/fb.png';
import inLogo from '../../assets/images/home/social/in.png';
import ttLogo from '../../assets/images/home/social/tt.png';
import LeftArrowBold from '../../assets/images/icons/svg/left-arrow-bold.svg';
// import { black } from '../../common/colors';
import { pushToDataLayer } from '../../common/helpers/dataLayer';
import { toKey } from '../../common/helpers/strings';
import { useDebug } from '../../common/hooks/useDebug';
import { useTranslations } from '../../common/translation';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { TitleCarouselTwo } from '../../components/title-carousel/TitleCarouselTwo';
import { DefaultLayoutTwo } from '../default-two/DefaultLayoutTwo';
import { HomeTwoLayoutProps } from './HomeTwoLayout.props';
import {
  StyledHomeTwoCarouselWrapper,
  StyledHomeTwoDividerWrapper,
  StyledHomeTwoMainWrapper,
  StyledHomeTwoOverlayClose,
  StyledHomeTwoOverlayContent,
  StyledHomeTwoOverlayFormButton,
  StyledHomeTwoOverlayFormContent,
  StyledHomeTwoOverlayFormErrorText,
  StyledHomeTwoOverlayFormInput,
  StyledHomeTwoOverlayWrapper,
  StyledHomeTwoSignUpBtn,
  StyledHomeTwoSignUpMobileBtn,
  StyledHomeTwoTopLogo,
  StyledHomeTwoTopSocial,
  StyledHomeTwoTopSocialSection,
  StyledHomeTwoTopSocialSectionLinks,
  StyledHomeTwoTopWrapper,
  StyledHomeTwoWrapper,
} from './HomeTwoLayout.styles';
// import { useGetToken } from './hooks/useGetToken';
import { useSubmitSFMCData } from './hooks/useSubmitData';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const [currSection, setCurrSection] = useState('wb');
  const [userCountry, setUserCountry] = useState('');
  const [showOverlay, setShowOverlay] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);
  const [pausedIndex, setPausedIndex] = useState(-1);
  const [submitted, setSubmitted] = useState(false);
  // const { accessToken } = useGetToken();
  const { submissionData } = useSubmitSFMCData();
  const [debugState, setDebugState] = useState({ debugTxt: '', debug2Txt: '' });

  useDebug('app:layout:HomeTwoLayout:handleSubmit', {
    other: debugState,
  });

  useEffect(() => {
    if (pausedIndex !== -1) return; // pause when hovered

    const interval = setInterval(() => {
      setActiveIndex((prev) => {
        const nxt = (prev + 1) % 4;
        const secArr = ['wb', 'comedy', 'horror', 'epics'];
        setCurrSection(secArr[nxt]);
        return nxt;
      }); // loop 0 → 1 → 2 → 3 → 0...
    }, 5000);

    return () => clearInterval(interval);
  }, [pausedIndex]);

  const openOverlay = () => {
    /*if (showOverlay) {
      setEmail('');
      setError('');
      setPausedIndex(-1);
    } else {
      setPausedIndex(activeIndex);
    }
    setShowOverlay(!showOverlay);*/
    setPausedIndex(activeIndex);
    setShowOverlay(true);
  };

  const closeOverlay = () => {
    setEmail('');
    setError('');
    setSubmitted(false);
    setPausedIndex(-1);
    setShowOverlay(false);
  };
  const {
    bottomBannerProps,
    bottomCarouselProps,
    featuredBlogsProps,
    locale,
    middleCarouselProps,
    topBannerProps,
    topCarouselProps,
    translatedPaths,
  } = useRouteData<HomeTwoLayoutProps>();
  const { t } = useTranslations(translations, locale);

  const seo = {
    description: t(
      'seoDescription',
      'Home of Warner Bros Movies, TV Shows and Video Games including Harry Potter, DC Comics and more!',
    ),
  };

  useDebug('app:layout:HomeTwoLayout', {
    props: {
      bottomBannerProps,
      bottomCarouselProps,
      featuredBlogsProps,
      locale,
      middleCarouselProps,
      topBannerProps,
      topCarouselProps,
      translatedPaths,
    },
  });

  useEffect(() => {
    ['wb', 'comedy', 'horror', 'epics'].forEach((index) => {
      const img = new Image();
      img.src = `/assets/images/home/${index}/logo.png`;
    });

    const cimg = new Image();
    cimg.src = '/assets/images/home/comedy/clogo.png';

    fetch('https://d2nmfu57zhrblt.cloudfront.net/', { method: 'GET' })
      .then((response) => response.json())
      .then((data) => {
        // Code
        // console.log(data.CountryIsoCode);
        setUserCountry(data.CountryIsoCode);
      })
      .catch(() => {
        // catch error
        // console.log(err);
        setUserCountry('US'); // Default to US if error occurs
      });

    pushToDataLayer({ title: 'homepage' });
  }, []);

  useEffect(() => {
    // Lock scroll on the body and html elements when overlay is visible
    if (showOverlay) {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scroll when overlay is hidden
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
    }

    // Cleanup function to restore scroll when component is unmounted or overlay is hidden
    return () => {
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [showOverlay]);

  const handleOverlayClick = () => {
    closeOverlay();
  };

  const stopPropagation = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  const handleSubmit = async () => {
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!email.trim()) {
      setError('Email is required.');
    } else if (!emailRegex.test(email)) {
      setError('Invalid email address.');
    } else {
      // console.log('Submitted email:', email);
      // setShowOverlay(false);
      // setEmail('');
      // setError('');

      const formData = new FormData();
      formData.append('_clientID', '6379182');
      formData.append('_deExternalKey', 'GDPR_WarnerBros_Website_Registration');
      formData.append('_action', 'add');
      formData.append('_returnXML', '1');
      formData.append('EmailAddress', email);
      formData.append('IDENTIFIER_TYPE', 'Email');
      formData.append('CONSENTED_BUSINESS_ENTITY', 'Warner Bros. Entertainment Inc.');
      formData.append('WB_IP_PROPERTY_NAME', 'Warner Bros. US Portal');
      formData.append('CHILDREN_PROPERTY', 'N');
      formData.append('CONSENT_MEDIA_CHANNEL', 'Website');
      formData.append('EXPRESS_CONSENT_INDICATOR_FLAG', 'Y');
      formData.append('DATA_PRIVACY_POLICY_ACK', 'Y');
      formData.append(
        'DATA_PRIVACY_POLICY_ACK_LANGUAGE',
        'By clicking on the Subscribe button below, I agree to the Terms of Service and I acknowledge that I have read and understand the Privacy Policy.',
      );
      formData.append('DATA_PRIVACY_POLICY_URL', 'https://policies.warnerbros.com/privacy/en-us');
      formData.append('TERMS_OF_USE_ACK', 'Y');
      formData.append(
        'TERMS_OF_USE_ACK_LANGUAGE',
        'By clicking on the Subscribe button below, I agree to the Terms of Service and I acknowledge that I have read and understand the Privacy Policy.',
      );
      formData.append('TERMS_OF_USE_URL', 'https://www.warnerbros.com/terms');
      formData.append('MARKETING_NEWSLETTER_NAME', 'warnerbros.com Newsletter Signup');
      formData.append('MARKETING_OPT_IN_FLAG', 'Y');
      formData.append('WEBSITE_SOURCE_URL', 'www.warnerbros.com');
      formData.append('INDIVIDUAL_IDENTIFIER', email);
      formData.append('CONSENT_GEO_LOCATION_COUNTRY', userCountry);
      formData.append('CONSUMER_COUNTRY', userCountry);
      formData.append('AFFILIATED_PARTNER_CONSENT_FLAG', 'Y');
      formData.append(
        'AFFILIATED_PARTNER_CONSENT_LANGUAGE',
        'Yes! Warner Bros. Entertainment Inc. may also share my details with Warner Bros. Discovery affiliates so they may send me tailored email and other offers. Warner Bros. Entertainment Inc. is requesting this consent on behalf of its affiliates, which will use the information under their respective privacy policies.',
      );
      formData.append('AFFILIATED_PARTNER_URL', 'https://www.wbdprivacy.com/policycenter/affiliates/#affiliates');
      formData.append(
        'MARKETING_SIGN_UP_LANGUAGE',
        'Yes! Warner Bros. Entertainment Inc. may use my email address along with my interests and device data to send me tailored email and other offers through social media or other sites and apps',
      );

      try {
        const res = await submissionData(email, userCountry);
        setDebugState({
          debugTxt: 'SFMC submission:',
          debug2Txt: JSON.stringify(res),
        });
        if (res && res.errors) {
          setError('Failed to submit. Please try again later.');
        } else {
          if (res.data.query === null || res.data.query === undefined) {
            setError('No response from server. Please try again later.');
          } else {
            const message = res.data.query.message;
            const queryStatus = res.data.query.status;
            if (queryStatus) {
              setSubmitted(true);
            } else {
              setError(message);
            }
          }
        }

        /*await fetch('https://cl.s6.exct.net/DEManager.aspx', {
          method: 'POST',
          body: formData,
          mode: 'no-cors',
        });*/
        /*.then((response) => response.text())
          .then((xmlString) => {
            const parser = new DOMParser();
            const xml = parser.parseFromString(xmlString, 'text/xml');

            const statusMsg = xml.querySelector('status');
            const errorMsg = xml.querySelector('error');
            let debugTxt = '';
            const debug2Txt = 'xmlString :: ' + xmlString;
            if (statusMsg && statusMsg.textContent === 'OK') {
              debugTxt = 'Success! ' + statusMsg.textContent;
            } else if (errorMsg) {
              debugTxt = 'Error: ' + errorMsg.textContent;
            } else {
              debugTxt = 'Unknown response';
            }
            useDebug('app:layout:HomeTwoLayout:handleSubmit', { other: { debugTxt, debug2Txt } });
          });*/

        // setSubmitted(true);
      } catch (error) {
        // console.log('Submission failed. Please try again.', error);
        setError('Submission failed. Please try again.');
        setDebugState({
          debugTxt: 'SFMC submission:',
          debug2Txt: error,
        });
      }
      /*finally {
        setSubmitted(true);
      }*/
    }
  };

  let currLogo = '/assets/images/home/wb/logo.png';
  let currColor = '#05008ca1';
  let currBtmColor = '#04006c';
  let sepColor = '#005cfd';
  let btnGrad1Color = '#005cfd';
  let btnGrad2Color = '#005cfd';

  switch (currSection) {
    case 'wb':
      currLogo = '/assets/images/home/wb/logo.png';
      currColor = '#05008c';
      currBtmColor = '#04006c70';
      sepColor = '#015cfe';
      btnGrad1Color = '#015cfe';
      btnGrad2Color = '#0022af';
      break;
    case 'horror':
      currLogo = '/assets/images/home/horror/logo.png';
      currColor = '#6b1010';
      currBtmColor = '#510e0ea0';
      sepColor = '#ee2041';
      btnGrad1Color = '#ee2041';
      btnGrad2Color = '#6b1010';
      break;
    case 'comedy':
      currLogo = '/assets/images/home/comedy/clogo.png';
      currColor = '#015cfe';
      currBtmColor = '#015cfe90';
      sepColor = '#538cc6';
      btnGrad1Color = '#015cfe';
      btnGrad2Color = '#0044bd';
      break;
    case 'epics':
      currLogo = '/assets/images/home/epics/logo.png';
      currColor = '#360580';
      currBtmColor = '#30086ca0';
      sepColor = '#9000e8';
      btnGrad1Color = '#9000e8';
      btnGrad2Color = '#30086c';
      break;
  }
  const handleMouseEventWB = useCallback(
    (type: string) => {
      setCurrSection('wb');
      if (type === 'mouseenter') {
        setPausedIndex(0);
      } else {
        setPausedIndex(-1);
      }
      setActiveIndex(0);
    },
    [setCurrSection],
  );
  const handleMouseEventHorror = useCallback(
    (type: string) => {
      setCurrSection('horror');
      if (type === 'mouseenter') {
        setPausedIndex(2);
      } else {
        setPausedIndex(-1);
      }
      setActiveIndex(2);
    },
    [setCurrSection],
  );
  const handleMouseEventComedy = useCallback(
    (type: string) => {
      setCurrSection('comedy');
      if (type === 'mouseenter') {
        setPausedIndex(1);
      } else {
        setPausedIndex(-1);
      }
      setActiveIndex(1);
    },
    [setCurrSection],
  );
  const handleMouseEventEpics = useCallback(
    (type: string) => {
      setCurrSection('epics');
      if (type === 'mouseenter') {
        setPausedIndex(3);
      } else {
        setPausedIndex(-1);
      }
      setActiveIndex(3);
    },
    [setCurrSection],
  );
  const mouseEnterHandlers = [
    handleMouseEventWB.bind(null, 'mouseenter'),
    handleMouseEventWB.bind(null, 'mouseleave'),
    handleMouseEventComedy.bind(null, 'mouseenter'),
    handleMouseEventComedy.bind(null, 'mouseleave'),
    handleMouseEventHorror.bind(null, 'mouseenter'),
    handleMouseEventHorror.bind(null, 'mouseleave'),
    handleMouseEventEpics.bind(null, 'mouseenter'),
    handleMouseEventEpics.bind(null, 'mouseleave'),
  ];
  const handleInputEventChange = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail],
  );

  /* switch(currSection) {
    case 'wb': currLogo = baseLogo; currColor = '#05008c81'; sepColor = '#005cfd'; break;
    case 'horror': currLogo = horrorLogo; currColor = '#6b101081'; sepColor = '#ee2142'; break;
    case 'comedy': currLogo = comedyLogo; currColor = '#015cfe81'; sepColor = '#538bc6'; break;
    case 'epics': currLogo = epicsLogo; currColor = '#11012d81'; sepColor = '#8f00e8'; break;
  } */

  return (
    <>
      <Helmet>
        {['wb', 'comedy', 'horror', 'epics'].map((index) => (
          <link
            key={index}
            rel='preload'
            as='image'
            type='image/png'
            href={`/assets/images/home/${index}/logo.png`} // Adjust the path if needed!
          />
        ))}
        <link
          rel='preload'
          as='image'
          type='image/png'
          href={'/assets/images/home/comedy/clogo.png'} // Adjust the path if needed!
        />
      </Helmet>
      <DefaultLayoutTwo
        bgColor={currColor}
        hideBottomPadding={true}
        key={toKey(`${locale}-home`)}
        locale={locale}
        seo={seo}
        translatedPaths={translatedPaths}
        sectionVisible={currSection}
      >
        <HeadTitle title={t('pageTitle', 'Home of WB Movies, TV, Games, and more!')} />
        {showOverlay && (
          <StyledHomeTwoOverlayWrapper onClick={handleOverlayClick}>
            <StyledHomeTwoOverlayContent onClick={stopPropagation}>
              {submitted ? (
                <div>
                  <h3>Thank you for your submission.</h3>
                </div>
              ) : (
                <div>
                  <h3>Your Backstage Pass Awaits</h3>
                  <p>
                    Sign up to receive exclusive behind the scenes moments, new trailers, first looks, interviews, and
                    more.
                  </p>
                  <StyledHomeTwoOverlayFormContent>
                    <StyledHomeTwoOverlayFormInput
                      type='email'
                      placeholder='Email'
                      value={email}
                      onChange={handleInputEventChange}
                    />
                    <StyledHomeTwoOverlayFormButton onClick={handleSubmit}>
                      <img src={arrowBtn} alt='Arrow' />
                    </StyledHomeTwoOverlayFormButton>
                  </StyledHomeTwoOverlayFormContent>
                  {error && <StyledHomeTwoOverlayFormErrorText>{error}</StyledHomeTwoOverlayFormErrorText>}
                </div>
              )}
              <StyledHomeTwoOverlayClose src={closeBtn} onClick={closeOverlay} />
            </StyledHomeTwoOverlayContent>
          </StyledHomeTwoOverlayWrapper>
        )}
        <StyledHomeTwoMainWrapper>
          <StyledHomeTwoTopWrapper>
            <StyledHomeTwoTopLogo>
              <img src={currLogo} alt='Logo' />
            </StyledHomeTwoTopLogo>
            <StyledHomeTwoTopSocial>
              <StyledHomeTwoTopSocialSection
                id='wbSocialSection'
                key='wbSocialSection'
                onMouseEnter={mouseEnterHandlers[0]}
                onMouseLeave={mouseEnterHandlers[1]}
                className={`${activeIndex === 0 ? 'zoom' : ''}`}
              >
                <p>Follow</p>
                <p>@WarnerBros</p>
                <StyledHomeTwoTopSocialSectionLinks>
                  <a href='https://www.instagram.com/warnerbros' target='_blank' aria-label='Warnerbros Instagram'>
                    <img src={inLogo} alt='Instagram Logo WB' />
                  </a>
                  <a href='https://www.tiktok.com/@warnerbros' target='_blank' aria-label='Warnerbros Tiktok'>
                    <img src={ttLogo} alt='Tiktok Logo WB' />
                  </a>
                  <a href='https://www.facebook.com/WarnerBrosPictures' target='_blank' aria-label='Warnerbros FB'>
                    <img src={fbLogo} alt='FB Logo WB' />
                  </a>
                </StyledHomeTwoTopSocialSectionLinks>
              </StyledHomeTwoTopSocialSection>
              <StyledHomeTwoTopSocialSection
                id='comedySocialSection'
                key='comedySocialSection'
                onMouseEnter={mouseEnterHandlers[2]}
                onMouseLeave={mouseEnterHandlers[3]}
                className={`${activeIndex === 1 ? 'zoom' : ''}`}
              >
                <p>Follow</p>
                <p>@WarnerBrosComedy</p>
                <StyledHomeTwoTopSocialSectionLinks>
                  <a
                    href='https://www.instagram.com/warnerbroscomedy'
                    target='_blank'
                    aria-label='Warnerbros Comedy Instagram'
                  >
                    <img src={inLogo} alt='Instagram Logo Comedy' />
                  </a>
                  <a
                    href='https://www.tiktok.com/@warnerbroscomedy'
                    target='_blank'
                    aria-label='Warnerbros Comedy Tiktok'
                  >
                    <img src={ttLogo} alt='Tiktok Logo Comedy' />
                  </a>
                  <a
                    href='https://www.facebook.com/ComedyWarnerBros/'
                    target='_blank'
                    aria-label='Warnerbros Comedy FB'
                  >
                    <img src={fbLogo} alt='FB Logo Comedy' />
                  </a>
                </StyledHomeTwoTopSocialSectionLinks>
              </StyledHomeTwoTopSocialSection>
              <StyledHomeTwoTopSocialSection
                id='horrorSocialSection'
                key='horrorSocialSection'
                onMouseEnter={mouseEnterHandlers[4]}
                onMouseLeave={mouseEnterHandlers[5]}
                className={`${activeIndex === 2 ? 'zoom' : ''}`}
              >
                <p>Follow</p>
                <p>@WarnerBrosHorror</p>
                <StyledHomeTwoTopSocialSectionLinks>
                  <a
                    href='https://www.instagram.com/WarnerBrosHorror'
                    target='_blank'
                    aria-label='Warnerbros Horror Instagram'
                  >
                    <img src={inLogo} alt='Instagram Logo Horror' />
                  </a>
                  <a
                    href='https://www.tiktok.com/@warnerbroshorror'
                    target='_blank'
                    aria-label='Warnerbros Horror Tiktok'
                  >
                    <img src={ttLogo} alt='Tiktok Logo Horror' />
                  </a>
                  <a href='https://www.facebook.com/WarnerBrosHorror' target='_blank' aria-label='Warnerbros Horror FB'>
                    <img src={fbLogo} alt='FB Logo Horror' />
                  </a>
                </StyledHomeTwoTopSocialSectionLinks>
              </StyledHomeTwoTopSocialSection>
              <StyledHomeTwoTopSocialSection
                id='epicSocialSection'
                key='epicSocialSection'
                onMouseEnter={mouseEnterHandlers[6]}
                onMouseLeave={mouseEnterHandlers[7]}
                className={`${activeIndex === 3 ? 'zoom' : ''}`}
              >
                <p>Follow</p>
                <p>@WarnerBrosEpics</p>
                <StyledHomeTwoTopSocialSectionLinks>
                  <a
                    href='https://www.instagram.com/Warnerbrosepics/'
                    target='_blank'
                    aria-label='Warnerbros Epics Instagram'
                  >
                    <img src={inLogo} alt='Instagram Logo Epics' />
                  </a>
                  <a
                    href='https://www.tiktok.com/@warnerbrosepics'
                    target='_blank'
                    aria-label='Warnerbros Epics Tiktok'
                  >
                    <img src={ttLogo} alt='Tiktok Logo Epics' />
                  </a>
                  <a href='https://www.facebook.com/Warnerbrosepics/' target='_blank' aria-label='Warnerbros Epics FB'>
                    <img src={fbLogo} alt='FB Logo Epics' />
                  </a>
                </StyledHomeTwoTopSocialSectionLinks>
              </StyledHomeTwoTopSocialSection>
            </StyledHomeTwoTopSocial>
          </StyledHomeTwoTopWrapper>
          <StyledHomeTwoSignUpMobileBtn color={sepColor}>
            <p role='button' onClick={openOverlay}>
              <span>SIGN UP</span> FOR YOUR BACKSTAGE PASS <LeftArrowBold />
            </p>
          </StyledHomeTwoSignUpMobileBtn>
        </StyledHomeTwoMainWrapper>
        <StyledHomeTwoDividerWrapper color={sepColor} />
        <StyledHomeTwoCarouselWrapper color={currBtmColor}>
          <StyledHomeTwoWrapper>
            <TitleCarouselTwo {...topCarouselProps} headingTag='h1' lazyLoad={true} />
            <TitleCarouselTwo {...middleCarouselProps} headingTag='h1' lazyLoad={true} />
          </StyledHomeTwoWrapper>
          <StyledHomeTwoSignUpBtn color={sepColor} gradient1={btnGrad1Color} gradient2={btnGrad2Color}>
            <p role='button' onClick={openOverlay}>
              <span>SIGN UP</span> FOR YOUR BACKSTAGE PASS <LeftArrowBold />
            </p>
          </StyledHomeTwoSignUpBtn>
        </StyledHomeTwoCarouselWrapper>
      </DefaultLayoutTwo>
    </>
  );
};
